import { NgForOf, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { CommonModule } from '@angular/common';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';

type TabItem = {
    id: string;
    name: string;
};

type MembersItem = {
    id: string;
    name: string;
    title: string;
    titleId: string;
    avatar: string;
};

@Component({
    selector: 'app-team-members-section',
    imports: [NgForOf, NgIf, CommonModule],
    templateUrl: './team-members-section.component.html',
    styleUrl: './team-members-section.component.less',
})
export class TeamMembersSectionComponent {
    MAX_RESULT_COUNT_FOR_DESKTOP = 25;
    MAX_RESULT_COUNT_FOR_MOBILE = 15;

    selectedTab = '';
    tabs: TabItem[] = [];
    allTeamMembersGridForDesktop: MembersItem[][] = [];
    allTeamMembersGridForMobile: MembersItem[][] = [];
    allTeamMembersList: MembersItem[] = [];

    classificationId: string = '';
    skipCount: number = 0;
    maxResultCount: number = 25;

    totalCount: number = 0;
    isShowViewMore: boolean = true;
    defaultAvatarUrl = '../../../assets/images/about-us/default-avatar.svg';
    isTotalCountLessThan25: boolean = true;
    isTotalCountLessThan15: boolean = true;

    isMobile = false;
    private subscription!: Subscription;

    ngOnInit() {
        this.subscription = this.breakpointObserver.observe(['(max-width: 768px)']).subscribe((result) => {
            this.isMobile = result.matches;
            this.maxResultCount = this.isMobile ? this.MAX_RESULT_COUNT_FOR_MOBILE : this.MAX_RESULT_COUNT_FOR_DESKTOP;
            this.resetTeamMembers();
            this.getTeamMembers();
        });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    constructor(
        private httpClient: HttpClient,
        private breakpointObserver: BreakpointObserver
    ) {
        const teamMembersTabCount = 5;
        this.httpClient.get(`${environment.apiUrl}/Invoke/${teamMembersTabCount}`).subscribe((tabList: any) => {
            this.tabs = tabList;
            this.selectedTab = tabList[0].name;
            this.classificationId = tabList[0].id;
            this.getTeamMembers();
        });
    }

    getTeamMembers() {
        this.httpClient.get(`${environment.apiUrl}/Invoke/team-members?classificationId=${this.classificationId}&skipCount=${this.skipCount}&maxResultCount=${this.maxResultCount}`).subscribe((teamMembers: any) => {
            const { totalCount, items } = teamMembers;
            const teamMemberItems = items.map((item: MembersItem) => (item.avatar ? item : { ...item, avatar: this.defaultAvatarUrl }));
            this.allTeamMembersList.push(...teamMemberItems);
            this.allTeamMembersGridForDesktop = this.chunkArray(this.allTeamMembersList, 5);
            this.allTeamMembersGridForMobile = this.chunkArray(this.allTeamMembersList, 3);

            this.totalCount = totalCount;
            this.isTotalCountLessThan25 = totalCount < this.MAX_RESULT_COUNT_FOR_DESKTOP;
            this.isTotalCountLessThan15 = totalCount < this.MAX_RESULT_COUNT_FOR_MOBILE;

            this.isShowViewMore = this.allTeamMembersList.length !== this.totalCount;
        });
    }

    selectTab(tab: TabItem) {
        this.selectedTab = tab.name;
        this.classificationId = tab.id;
        this.resetTeamMembers();
        this.getTeamMembers();
    }

    chunkArray(teamMembersList: MembersItem[], columnsCount: number) {
        const matrix = [];
        for (let i = 0; i < teamMembersList.length; i += columnsCount) {
            matrix.push(teamMembersList.slice(i, i + columnsCount));
        }

        return matrix;
    }

    OnViewMoreClick() {
        this.skipCount = this.skipCount + this.maxResultCount;
        this.getTeamMembers();
    }

    OnCollapseAllClick() {
        this.resetTeamMembers();
        this.getTeamMembers();
    }

    resetTeamMembers() {
        this.skipCount = 0;
        this.allTeamMembersList = [];
        this.allTeamMembersGridForDesktop = [];
        this.allTeamMembersGridForMobile = [];
    }
}
